export const getErrorValue = (errorObject, errorKey, requiredKey) => {
  if (errorObject?.[requiredKey]) {
    return "Required";
  }

  if (errorObject?.[errorKey]) {
    return errorObject[errorKey];
  }

  return null;
};

export const handleErrors = (
  errorObject,
  key,
  value,
  maxFieldLength,
  isMandatary = true
) => {
  const newErrorObject = { ...errorObject };

  // Clear existing error for the key
  newErrorObject[key] = false;

  if (isMandatary && value?.trim()?.length <= 0) {
    newErrorObject[key] = `Required`;
  }

  // Set new error if value length exceeds maxFieldLength
  if (maxFieldLength && value.length >= maxFieldLength) {
    newErrorObject[key] = `Maximum field length of ${maxFieldLength} reached.`;
  }

  return newErrorObject;
};

/**
 * Validates an error object by checking if it contains any non-empty strings or true values.
 *
 * @param {Object} errorObj - The error object to be validated.
 * @returns {boolean} True if the error object contains at least one non-empty string or true value, otherwise false.
 */
export const validateErrorObject = (errorObj) => {
  for (const key in errorObj) {
    if (Object.prototype.hasOwnProperty.call(errorObj, key)) {
      const value = errorObj[key];
      if (typeof value === "string" || value === true) {
        return true;
      }
    }
  }
  return false;
};
